import { Component, EventEmitter, Input, Output } from '@angular/core';
@Component({
    selector: 'app-session-timed',
    templateUrl: './session-timed.component.html',
    styleUrls: ['./session-timed.component.css'],
    standalone: false
})
export class SessionTimedComponent {
  @Input() remainingSeconds = 5 * 60;
  @Output() continueWorking = new EventEmitter<void>();
  @Output() logOff = new EventEmitter<void>();

  get formattedRemainingTime(): string {
    const minutes = Math.floor(this.remainingSeconds / 60);
    const seconds = this.remainingSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  onContinueWorking(): void {
    this.continueWorking.emit();
  }

  onLogOff(): void {
    this.logOff.emit();
  }
}
